import { TaskDriverStatusEnum } from "@/domain/models/common";
import { useTranslator } from "@/i18n/useTranslator";

import { DriverDashboardSection, DriverFlowBottomButton } from "../blocks";
import { DsText } from "../components/ui";
import { useUpdateAllDriverDumpServicesMutation } from "../data/mutations/serviceMutations";
import { useUpdateAllDriverDumpTasksMutation } from "../data/mutations/taskMutations";
import { useTasksToDumpQuery } from "../data/queries/taskQueries";

const DriverDriveToDump = () => {
  const { t } = useTranslator();

  const {
    mutate: updateAllDriverDumpTasks,
    isPending: isUpdatingAllDriverDumpTasks,
  } = useUpdateAllDriverDumpTasksMutation();
  const {
    mutate: updateAllDriverDumpServices,
    isPending: isUpdatingAllDriverDumpServices,
  } = useUpdateAllDriverDumpServicesMutation();

  const { data: tasksToDump } = useTasksToDumpQuery();

  const onNextClick = () => {
    updateAllDriverDumpTasks({
      driverFlowStatus: TaskDriverStatusEnum.FILLING_WEIGHT_SURCHARGE,
    });

    updateAllDriverDumpServices({
      driverFlowStatus: TaskDriverStatusEnum.FILLING_WEIGHT_SURCHARGE,
    });
  };

  const isNextButtonLoading =
    isUpdatingAllDriverDumpTasks || isUpdatingAllDriverDumpServices;

  return (
    <div className="flex flex-col h-full w-full">
      <DsText variant="pageTitle">{t("driver_drive_to_dump.title")}</DsText>

      <div className="h-full mt-4">
        {/* Tasks to dump */}
        <DriverDashboardSection
          title="driver_dashboard.jobs_to_dump"
          variant="dataDisplayTitle"
          titleClassName="mb-0"
          tasks={tasksToDump ?? []}
          shouldBlockTaskClick
          shouldApplyDisabledStyles={false}
          shouldShowInProgressBadge={false}
        />
      </div>

      <DriverFlowBottomButton
        onNextButtonClick={() => {
          void onNextClick();
        }}
        isNextButtonLoading={isNextButtonLoading}
        nextButtonTitle="driver_drive_to_dump.next_button"
      />
    </div>
  );
};

export { DriverDriveToDump };
